<section class="h-[25.6rem] w-[51.2rem] flex items-center justify-center bg-white" role="dialog"
    aria-modal="true" aria-labelledby="payment-message-title">
    <div class="flex flex-col gap-[4rem] w-[25.6rem] h-[12.6rem]">
        <mat-dialog-content class="!max-h-none !m-0 !p-0 flex items-center justify-center text-center">
            <div class="!max-h-none !m-0 !p-0 overflow-y-auto flex items-center justify-center text-center h-full">
                <div id="payment-message-title" [ngClass]="data.classes">
                    <span class="uppercase text-center text-black dsr-typescale-body-medium"> {{data.message}}
                    </span>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions class="!min-h-fit !m-0 !p-0 flex gap-[1.6rem] font-[600] text-[1.6rem] items-center justify-center">
            <button mat-flat-button class="" (click)="closeDialog()" type="button">
                <span class="uppercase"> {{ "OK_BUTTON" | translate }} </span>
            </button>
        </mat-dialog-actions>
    </div>
</section>